import { useSelector } from "utils/redux";

type PlanCoverages = {
  part_a_b_coverages: Array<unknown>;
  part_c_d_coverages: Array<unknown>;
};

export const useCoverage = (planCoverages: PlanCoverages) => {
  const hasCoverage =
    planCoverages?.part_a_b_coverages?.length > 0 ||
    planCoverages?.part_c_d_coverages?.length > 0;

  const validationErrors = useSelector((state) => state.main.validationErrors);
  const hasCoverageValidationErrors =
    validationErrors.filter((error) =>
      error.message.includes("coverage is missing required fields"),
    ).length > 0;

  const coverageState = useSelector((state) => state.futureMedical);

  return {
    hasCoverage,
    hasCoverageValidationErrors,
    coverageState,
  };
};
